function loopElapsed(elapsed, duration) {
  let delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return elapsed - duration - delay;
}
function reverseElapsed(elapsed, duration) {
  let delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  let isForwardPlayback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return isForwardPlayback ? loopElapsed(duration + -elapsed, duration, delay) : duration - (elapsed - duration) + delay;
}
function hasRepeatDelayElapsed(elapsed, duration, delay, isForwardPlayback) {
  return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
}
export { hasRepeatDelayElapsed, loopElapsed, reverseElapsed };